//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.GPodDefaultSettingsForm.ts           </Name>
//    <Description>                                                             </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-06-05                                                  </Created>
//  </FileHeader>



namespace Gordic.Pod.AppSettings {
    /**
     * Cesta k objetu nastavení defaultníchg hodnot v GStore.
     * 
     * @author  JSindelka
     * @date    30.04.2019
     */
    export const DefaultSettingsPath = "Global.Pod.AppSettings.PodDefaultSettings"

    /**
     * Vrátí hodnoty uživatelského nastavení defaultníchg hodnot.
     *
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @returns {Gordic.Pod.WebControls.GPodDefaultSettingsDto} Hodnoty uživatelského nastavení defaultníchg hodnot.
     */
    export function GetPodDefaultSettings(): Gordic.Pod.Interface.GPodDefaultSettingsDto {
        const settings: Gordic.Pod.Interface.GPodDefaultSettingsDto | null | undefined = (window as any).gstor.get(DefaultSettingsPath, true);
        if (settings) {
            return settings;
        } else {
            return {  

            };
        }
    }

    /**
     * Nastaví hodnoty uživatelského nastavení defaultníchg hodnot.
     *  
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @param {Gordic.Pod.WebControls.GPodDefaultSettingsDto | null} value Hodnoty uživatelského nastavení defaultníchg hodnot.
     */
    export function SetPodDefaultSettings(value: Gordic.Pod.Interface.GPodDefaultSettingsDto | null): void {
        (window as any).gstor.set(DefaultSettingsPath, value);
    }

    /**
     * Formulář uživatelského nastavení podání.
     *
     * @author  JSindelka
     * @date    30.04.2019
     */
    export function PodDefaultSettingsForm(): Forms.Form {
        const formName = "PodDefaultSettingsForm";
        let modelProperty: (keyof Gordic.Pod.Interface.GPodDefaultSettingsDto) | undefined;

        const form = new Gordic.Forms.Form({
            name: formName,
            tabOptions: {
                title: "jres:31950090", //RC 31950090 : Základní nastavení (Dialog profilu dokumentu v podatelně)
                opened: false
            }
        } as any);

        form.addSection() 
        


        form.addPrefab(Wfl.Prefabs.GZpusobDoruceni(
            {

                model: DefaultSettingsPath + "." + (modelProperty = "ZpusobDoruceni") + "=value.zpusob_dor",

            })
        );
        form.addPrefab(Wfl.Prefabs.GZvlastniZachazeni(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "DruhZachazeniDoruceni") + "=value.druh_zas_zach",
            })
        );

        form.addPrefab(Wfl.Prefabs.GDruhZasilky(
            undefined,  // TODO ZDA FUNGUJE jinak poslat vlastní change do políčka a to odstřihne ten nastavovací ansabl co by padal
            {
                model: DefaultSettingsPath + "." + (modelProperty = "DruhZasilkyDoruceni") + "=value.druh_zas",
            })
        );
        form.addPrefab(Wfl.Prefabs.GPristup(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "StupUtaj") + "=value.st_utaj_id",
            }
        ));
        form.addRow().addField("gcheck", {
            name: "PristupPlnitDleTypuDok",
            label: "jres:31950094", //RC 31950094 : Plnit dle typu dokumentu
            model: DefaultSettingsPath + "." + (modelProperty = "PristupPlnitDleTypuDok") + "=value",
            change: function (ev, changeObj) {
                if (changeObj.value) {
                    //TODO
                } else {
                }
            }

        });

        form.addRow().addField("gcheck", {
            name: "PreskocitZVecPo50DoVecPodrobne",
            label: "jres:31950100", //RC 31950100 : Přeskočit po 50 znacích z věci do věci podrobně
            model: DefaultSettingsPath + "." + (modelProperty = "PreskocitZVecPo50DoVecPodrobne") + "=value",

        });

        form.addPrefab(Wfl.Prefabs.GPocetListu(

            ($.content("main") as any).wflDBParams,
            {
                model: DefaultSettingsPath + "." + (modelProperty = "PocListu") + "=value",
                validators: []
            },
            {
                model: DefaultSettingsPath + "." + (modelProperty = "PocStran") + "=value",

            },
            {
                model: DefaultSettingsPath + "." + (modelProperty = "PocPriloh") + "=value",
                validators: []

            },
            {
                model: DefaultSettingsPath + "." + (modelProperty = "PocListuPriloh") + "=value",


            },
            {
                model: DefaultSettingsPath + "." + (modelProperty = "PocKopii") + "=value",
            },
            undefined,
            undefined,
            undefined,
            true
        ));

        form.addPrefab(Wfl.Prefabs.GTypPisemnosti(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "TypPis") + "=value.ixs_typ",

            })
        );
        form.addRow().addField("gcheck", {
            name: "TypDokAktivitaSSL",
            label: "jres:31950101", //RC 31950101 : Pouze aktivní v SSL
            model: DefaultSettingsPath + "." + (modelProperty = "TypDokAktivitaSSL") + "=value",
            change: function (ev, changeObj) {

                var TypPis = $(this).gform().findFields(Wfl.Prefabs.FieldNames.typPisemnosti);
                var srvFil;
                if (changeObj.value) {
                    srvFil = { FilterAktivitaSsl: 100 };
                } else {
                    srvFil = { FilterAktivita: 100 };
                }


                TypPis.gfield("option", "serverFilters", srvFil);
            }
        });
        form.addPrefab(Wfl.Prefabs.GSpisovyZnak(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "SpisZnak_spis_pl") + "=value.spis_pl",
            },
            {
                model: DefaultSettingsPath + "." + (modelProperty = "SpisZnak_spis_pl") + "=value.spis_pl" + ";"
                    + DefaultSettingsPath + "." + (modelProperty = "SpisZnak_spis_znak") + "=value.spis_znak"
            }
        ));
        form.addRow().addField("gcheck", {
            name: "SpZnakPlnitDleTypuDok",
            label: "jres:31950094", //RC 31950094 : Plnit dle typu dokumentu
            model: DefaultSettingsPath + "." + (modelProperty = "SpZnakPlnitDleTypuDok") + "=value",
        });

        form.addPrefab(Wfl.Prefabs.GPosta(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "Psc") + "=value.psc" + ";" +
                    DefaultSettingsPath + "." + (modelProperty = "Stat") + "=value.stat"
            })
        );
        form.addPrefab(Wfl.Prefabs.GStat(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "Stat") + "=value.stat"

            })
        );
        form.addRow().addField("gcheck", {
            name: "Evidovat",
            model: DefaultSettingsPath + "." + (modelProperty = "Evidovat") + "=value",
            label: "jres:31950093", //RC 31950093 : Evidovat

            change: function (ev, changeObj) {
                if (changeObj.value) {
                    //TODO
                } else {
                }
            }
        });
        form.addRow().addField("gcheck", {
            name: "DotazPredEvidenci",
            label: "jres:31950099", //RC 31950099 : Zobrazit kontrolní dotaz před evidencí
            model: DefaultSettingsPath + "." + (modelProperty = "DotazPredEvidenci") + "=value",

        });





        form.addSection("jres:31950095") //RC 31950095 : Cíl přidělení/ předání
        form.addPrefab(Wfl.Prefabs.GIdentifikatorSU({
            fieldOpt: {
                model: function () { return; } // DefaultSettingsPath + "." + (modelProperty = "IxsSU")"=value"

            }
        }));
        /*
        form.addPrefab(Wfl.Prefabs.GVlastnik(
            {
                model: DefaultSettingsPath + "." + (modelProperty = "SUFuncRefPredani_IxsFun") + "=value.ixs_fun" + ";"
                     + DefaultSettingsPath + "." + (modelProperty = "SUFuncRefPredani_IxsSu") + "=value.ixs_su",
                serverFilters: {
                    // aktivita: [100],
                    DlePovolenychAgend: true
                },
            },
            {
                label: "jres:31950091" //RC 31950091 : Cíl přidělení / předání
            }
        ));
        */
        form
            .addRow("jres:31950091") //RC 31950091 : Cíl přidělení / předání
            .addField("gselectbox", "w-12", Gin.Prefabs.Field.SpisovyUzel({
                name: "IxsSu",
                model: DefaultSettingsPath + "." + (modelProperty = "SUFuncRefPredani_IxsSu") + "=value.ixs_su",
                placeholder: "jres:31950286" //RC 31950286 : Spisový uzel
            }, false))
            .addField("gselectbox", "w-12", Gin.Prefabs.Field.Funkce({
                model: DefaultSettingsPath + "." + (modelProperty = "SUFuncRefPredani_IxsFun") + "=value.ixs_fun",
                serverFilters: {
                    aktivita: [100],
                    DlePovolenychAgend: true,
                    //this.model.Prebirajici.ixs_su
                    ixs_su: new Gordic.Forms.Dependency("IxsSu", Gordic.Data.Readers.GinspodDtoNames.ixs_su, true, true),
                },
                placeholder: "jres:31950287" //RC 31950287 : Funkce
            }, false));

        var poleRedistribuce = [];
        poleRedistribuce.push({ val: "neurceno", label: "jres:31950314" });
       

        if ( !(($.content("main") as any).applicationRevision.indexOf("SSD05") !== -1)) {
            if (($.content("main") as any).wflDBParams.ssl_pridel_prpo == 1) {//enableDto.PridelitPrimoEnabled
                poleRedistribuce.push({ val: "Pridelit", label: "jres:31950317" }); //RC 31950317 : Přidělit
            }
            poleRedistribuce.push({ val: "PridelitPrimo", label: "jres:31950315" }); //RC 31950315 : Přidělit přímo
        }

        poleRedistribuce.push({ val: "Predat", label: "jres:31950316" }); //RC 31950316 : Předat


        form.addRow("jres:31950092").addField("gselectbox", { //RC 31950092 : Redistribuce
            name: "Redistribuce",
            list: true,
            itemTemplate: "{label}",
            model: DefaultSettingsPath + "." + (modelProperty = "Redistribuce") + "=value.val",
            initialValue: { val: "neurceno" },
            data: new Gordic.Data.View(poleRedistribuce, { key: "val" }),
            itemWidth: "",

            change: function (ev, changeObj) {

            }
        });

        
        form.addSection("jres:31950085") //RC 31950085 : Rozšířený profil
        form.addRow().addField("gcheck", {
            name: "RozsirenyProfilPrednastavit",
            label: "jres:31950096", //RC 31950096 : Přednastavit
            model: DefaultSettingsPath + "." + (modelProperty = "RozsirenyProfilPrednastavit") + "=value",

        });
        form.addRow().addField("gcheck", {
            name: "RozsirenyProfilZakazat",
            label: "jres:31950097", //RC 31950097 : Zakázat
            model: DefaultSettingsPath + "." + (modelProperty = "RozsirenyProfilZakazat") + "=value",
            change: function (ev, changeObj) {
                var RozsirenyProfilPrednastavit = $(this).gform().findFields("RozsirenyProfilPrednastavit");
                var VytvoritSpisPrednastavit = $(this).gform().findFields("VytvoritSpisPrednastavit");
                var VytvoritSpisZakazat = $(this).gform().findFields("VytvoritSpisZakazat");
                if (changeObj.value) {
                    RozsirenyProfilPrednastavit.gfield("setValue", false);
                    RozsirenyProfilPrednastavit.gfield("option", "disabled", true);
                    VytvoritSpisPrednastavit.gfield("setValue", false);
                    VytvoritSpisPrednastavit.gfield("option", "disabled", true);
                    VytvoritSpisZakazat.gfield("setValue", true);
                    VytvoritSpisZakazat.gfield("option", "disabled", true);
                } else {
                    RozsirenyProfilPrednastavit.gfield("option", "disabled", false);
                    VytvoritSpisPrednastavit.gfield("option", "disabled", false);
                    VytvoritSpisZakazat.gfield("setValue", false);
                    VytvoritSpisZakazat.gfield("option", "disabled", false);
                }
            }


        });
        form.addSection("jres:31950098") //RC 31950098 : Vytvořit spis
        form.addRow().addField("gcheck", {
            name: "VytvoritSpisPrednastavit",
            label: "jres:31950096", //RC 31950096 : Přednastavit
            model: DefaultSettingsPath + "." + (modelProperty = "VytvoritSpisPrednastavit") + "=value",


        });
        form.addRow().addField("gcheck", {
            name: "VytvoritSpisZakazat",
            label: "jres:31950097", //RC 31950097 : Zakázat
            model: DefaultSettingsPath + "." + (modelProperty = "VytvoritSpisZakazat") + "=value",
            change: function (ev, changeObj) {
               
                var RozsirenyProfilPrednastavit = $(this).gform().findFields("RozsirenyProfilPrednastavit");
                if (changeObj.value) {
                    RozsirenyProfilPrednastavit.gfield("setValue", false);
                    RozsirenyProfilPrednastavit.gfield("option", "disabled",true);
                } else {
                    RozsirenyProfilPrednastavit.gfield("option", "disabled", false);
                }
            }

        });


        //form.addPrefab(Wfl.Prefabs.GVec(
        //    this.userSettings,
        //    {
        //        model: function () { return;}

        //    }
        //));

        return form;
    }
}